import React, { Component } from 'react';
import HeroItem from '../HeroItem/HeroItem';
import Slider from 'react-slick';

import './Hero.css';

export default class Hero extends Component {

    render() {
        let items = [];

        let size = 'large';
        if(this.props.size) {
            size = this.props.size;
        }

        for(const item of this.props.items) {
            items.push(<HeroItem key={item.get('id')} building={this.props.building} drupal={this.props.drupal} item={item} size={size} />)
        }

        if(items.length > 1) {
            const sliderSettings = {
                dots: true,
                arrows: false,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                beforeChange: (_, newIndex) => {
                  const active = document.activeElement;
                  if (!active) return;

                  const slide = active.closest(".slick-slide");
                  if (!slide) return;

                  const idx = Number(slide.getAttribute("data-index"));
                  if (idx !== newIndex) {
                    active.blur();
                  }
                },
                dotsClass: 'slick-dots container'
            };
    
            items = <Slider {...sliderSettings}>{items}</Slider>;
        }

        return (
            <div className="hero">
                {items}
            </div>
        );
    }
}
